import { AppModal } from 'shared/UI/UIKit/Modal';
import { MaxLessonsPerDayForm } from 'entities/max-lessons-per-day/form';
import { AppButton } from 'shared/UI/UIKit/Button';
import { AppFlex } from 'shared/UI/UIKit/Flex';
import { AppCopyIcon } from 'shared/UI/UIKit/icons/Copy';
import type { MaxLessonsPerDay } from 'shared/api';
import { useMaxLessonsPerDayCopy } from '../model';
import styles from './styles.module.scss';

interface MaxLessonsPerDayCopyProps {
  maxLessonsPerDay: MaxLessonsPerDay;
  refreshTable: () => void;
}

export const MaxLessonsPerDayCopy = ({
  maxLessonsPerDay,
  refreshTable,
}: MaxLessonsPerDayCopyProps) => {
  const {
    state: { modalVisible, form },
    methods: { showModal, hideModal, onSubmit },
  } = useMaxLessonsPerDayCopy({ maxLessonsPerDay, refreshTable });

  return (
    <>
      <AppCopyIcon className={styles.icon} onClick={showModal} />

      <AppModal
        content={<MaxLessonsPerDayForm form={form} />}
        title="Новая конфигурация"
        visible={modalVisible}
        onCancel={hideModal}
        destroyOnClose
        footer={
          <AppFlex direction="row">
            <AppButton type="primary" onClick={onSubmit}>
              Создать
            </AppButton>
            <AppButton type="outline" onClick={hideModal}>
              Закрыть
            </AppButton>
          </AppFlex>
        }
      />
    </>
  );
};
